declare namespace $ {

	export class $shm_hitalama_process_monitor_maps extends $shm_hitalama_process_monitor {
	}
	
}

//# sourceMappingURL=maps.view.tree.d.ts.map